import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

// Helpers de formulário
import InputMask from 'react-input-mask';
import Select from 'react-select';
import Toggle from 'react-toggle';

import StaffCertificationAddFile from './StaffCertificationAddFile';
import getLocale from '../../../i18n/getLocale';

class StaffCertificationsTypeTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: false,
      staff_id: this.props.staff_id,
      date_start: '',
      date_finish: '',
      pf: 0,
      only_active: 1,
      certification_id: null,
      certification_supplier_id: null,
      observations: '',
      staff_certifications: [],
      certifications: [],
      certification_suppliers: [],
    };

    //bind específico
    // this.add = this.add.bind(this);
    // this.activate = this.activate.bind(this);
    // this.delete = this.delete.bind(this);
    // this.archive = this.archive.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.refreshDataActive = this.refreshDataActive.bind(this);

    this.locale = getLocale();
  }
  // Handlers
  // handleChange (name, event) {
  //   var change = {};
  //   change[name] = event.target.value;
  //   this.setState(change);
  // } 
  // handleSelectChange(name, event) {
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;
  //   }
  //   this.setState(change);
  // }
  // handleToggleChange (name, event) {
  //   var change = {};
  //   if (event.target.checked === true) {
  //     var value = 1;
  //   } else {
  //     var value = 0;
  //   }
  //   change[name] = value;
  //   this.setState(change);
  // } 

  // handleSelectChangeCertification(name, event) {
  //   this.props.handleAlert('', '', 'open');
  //   var change = {};
  //   if(event == null) {
  //     change[name] = null;
  //   } else {
  //     change[name] = event.value;

  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     if (event.value !== null) {
  //       Promise.resolve(header).then(function(value) {
  //         fetch(config.get('api') + '/certificado/fornecedores/lista/' + event.value , { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //           self.setState({certification_suppliers: responseJson.data});
  //           self.props.handleAlert(responseJson.message, responseJson.status, 'closed');
  //         });
  //       });      
  //     }
  //   }
  //   this.setState(change);
  // }

  // LM
  componentWillReceiveProps(newProps) {
    if(Array.isArray(newProps.staff_certifications_other_type) && this.state.loaded === false) {
      this.setState({
        certifications: newProps.certifications,
        staff_certifications: newProps.staff_certifications_other_type,
        loaded: true
      });
    }
  }
  
  // Fetch salvando a edição
  // add(event) {
  //   event.preventDefault();
  //   this.props.handleAlert('', '', 'open');
  //   var datasave = {
  //     staff_id: this.props.staff_id,
  //     date_start: this.state.date_start,
  //     date_finish: this.state.date_finish,
  //     pf: this.state.pf,
  //     certification_id: this.state.certification_id,
  //     certification_supplier_id: this.state.certification_supplier_id,
  //     observations: this.state.observations,
  //   };
  //   var header = this.refs.request_api.header('application/json');
  //   var self = this;
  //   Promise.resolve(header).then(function(value) {
  //     fetch(config.get('api') + '/funcionario/certificado', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //       self.refs.request_api.validate(responseJson, 'alert');
  //       self.refreshData();
  //       self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //     }).catch((error) => {
  //       console.error(error);
  //     });
  //   });
  // }
  
  // // Fetch ativando um item
  // activate(event) {
  //   var id = event.currentTarget.value;
  //   var confirm = window.confirm('Tem certeza que gostaria de ativar esse certificado?');
  //   if (confirm) {
  //     this.props.handleAlert('', '', 'open');
  //     var datasave = {
  //       id: id,
  //     };
  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api') + '/funcionario/certificado/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         if (responseJson.status === 'success') {
  //           if(self.state.only_active === 0){
  //             self.refreshDataActive();
  //           } else{      
  //             self.refreshData();
  //           }
  //         }
  //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });      
  //   }
  // }
  
  // // Fetch deletando um item
  // archive(event) {
  //   var id = event.currentTarget.value;
  //   var confirm = window.confirm('Tem certeza que gostaria de arquivar esse certificado?');
  //   if (confirm) {
  //     this.props.handleAlert('', '', 'open');
  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api') + '/funcionario/certificado/arquivar/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         if (responseJson.status === 'success') {
  //           if(self.state.only_active === 0){
  //             self.refreshDataActive();
  //           } else{      
  //             self.refreshData();
  //           }
  //         }
  //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });      
  //   }
  // }
  // // Fetch deletando um item
  // delete(event) {
  //   var id = event.currentTarget.value;
  //   var confirm = window.confirm('Tem certeza que gostaria de deletar esse certificado?');
  //   if (confirm) {
  //     this.props.handleAlert('', '', 'open');
  //     var header = this.refs.request_api.header('application/json');
  //     var self = this;
  //     Promise.resolve(header).then(function(value) {
  //       fetch(config.get('api') + '/funcionario/certificado/' + id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
  //         self.refs.request_api.validate(responseJson, 'alert');
  //         if (responseJson.status === 'success') {
  //           if(self.state.only_active === 0){
  //             self.refreshDataActive();
  //           } else{      
  //             self.refreshData();
  //           }
  //         }
  //         self.props.handleAlert(responseJson.message, responseJson.status, 'open');
  //       }).catch((error) => {
  //         console.error(error);
  //       });
  //     });      
  //   }
  // }

  refreshData () {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/funcionario/certificados/tipo/' + self.state.staff_id, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({staff_certifications: responseJson.data, only_active: 0});
        }
        self.props.handleAlert('', '', 'closed');
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  refreshDataActive () {
    this.props.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/funcionario/certificados/ativos/tipo/' + self.state.staff_id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson);
        if (responseJson.status === 'success') {
          self.setState({staff_certifications: responseJson.data, only_active: 1});
        }
        self.props.handleAlert('', '', 'closed');
      }).catch((error) => { 
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">{this.locale.ColaboradoresSigtrip.EditarFuncionario.tabAvaliacoes.tituloAvaliacoes}</h3>
  <hr/>
  {(this.state.staff_certifications === null || typeof this.state.staff_certifications === 'undefined') ?  <div><small><em>{this.locale.ColaboradoresSigtrip.EditarFuncionario.tabAvaliacoes.nenhumCertificadoCadastrado}</em></small><hr/></div> 
  : 
  <div>
    <table className="table table-bordered table-stripped table-hover">
      <thead>
        <tr>
          <th className="text-center">{this.locale.ColaboradoresSigtrip.EditarFuncionario.tabAvaliacoes.tabela.NomeDoCertificado}</th>
          <th className="text-center">{this.locale.ColaboradoresSigtrip.EditarFuncionario.tabAvaliacoes.tabela.Inicio}</th>
          <th className="text-center">{this.locale.ColaboradoresSigtrip.EditarFuncionario.tabAvaliacoes.tabela.Fim}</th>
          <th className="text-center">{this.locale.ColaboradoresSigtrip.EditarFuncionario.tabAvaliacoes.tabela.Vencimento}</th>
          <th className="text-center">{this.locale.ColaboradoresSigtrip.EditarFuncionario.tabAvaliacoes.tabela.Status}</th>
          <th className="text-center">{this.locale.ColaboradoresSigtrip.EditarFuncionario.tabAvaliacoes.tabela.Arquivo}</th>
        </tr>
      </thead>
      <tbody id="suppliers-certifications">
        {Object.keys(self.state.staff_certifications).map(function(k) {
          return (
            <tr>
              <td className="text-center">{self.state.staff_certifications[k].certification}</td>
              <td className="text-center">{self.state.staff_certifications[k].date_start_str}</td>
              <td className="text-center">{self.state.staff_certifications[k].date_finish_str}</td>
              <td className="text-center">
                {(self.state.staff_certifications[k].expire_status_int === 0) ?  <span className="text text-success">{self.state.staff_certifications[k].expire_str}</span> : <span className="text text-danger">{self.state.staff_certifications[k].expire_str}</span>}
              </td>
              <td className="text-center">{(self.state.staff_certifications[k].active === 1) ?  <span className="label label-success">{self.locale.ColaboradoresSigtrip.EditarFuncionario.tabAvaliacoes.tabela.Ativo}</span> : <span className="label label-danger">{self.locale.ColaboradoresSigtrip.EditarFuncionario.tabAvaliacoes.tabela.Arquivado}</span>}</td>
              <td className="text-center">
                <StaffCertificationAddFile handleAlert={self.props.handleAlert} refreshData={self.refreshData} staff_certification_id={self.state.staff_certifications[k].id} file={self.state.staff_certifications[k].file} file_archived={self.state.staff_certifications[k].file_archived} />
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
    <hr/>
  </div>
  }
</div>
    );
  }
}

export default StaffCertificationsTypeTab;



// WEBPACK FOOTER //
// ./src/Components/SigtripStaffs/Elements/StaffCertificationsTypeTab.js